module.exports = __webpack_public_path__ + "img/results_hw_time_series.e3848e7d.png";